import { forwardRef } from 'preact/compat';
import { mapBrFromString } from '@/utils';
import HandleTabIndex from './HandleTabIndex';

const PlainText = forwardRef(function PlainText({ text, ...props }, ref) {
	return (
		<HandleTabIndex
			ref={ref}
			{...props}
		>
			{mapBrFromString(text)}
		</HandleTabIndex>
	);
});

export default PlainText;
